import $ from 'jquery';
import Component from "../models/Component";
import Shuffle from "shufflejs";

export default class GalleryFilter extends Component {
  constructor(element, context) {
    super(element, context);
    $(() => {
      this.filters = this.element.find('.filter');
      this.init();
    });
  }

  init() {
    this.shuffleInstance = new Shuffle(this.element.find('.gallery-container').get(0), {
      itemSelector: '.gallery-item-col',
      sizer: '.gallery-item-sizer',
    });
    this.filters.on('click', (e) => {
      const link = $(e.currentTarget),
        filter = link.data('filter');
      if (link.hasClass('active')) {
        return false;
      }
      if (filter === 'all') {
        this.shuffleInstance.filter(Shuffle.ALL_ITEMS);
      } else {
        this.shuffleInstance.filter(filter);
      }
      this.filters.removeClass('active');
      link.addClass('active');
      return false;
    });
  }
}
